import { useTranslation } from 'react-i18next';

import { Version } from '../Version';
import { HostsharingLogo } from './HostsharingLogo';

const SITE = 'https://www.hostsharing.net';

/*
 * The page footer. Its right half is the one www.hostsharing.net puts at
 * the foot of every page — privacy, contact, imprint, then the logo
 * linking home, in that order — while the left half stays ours: which
 * build is running. The labels come from the translation files rather
 * than from the site, so the footer speaks the language of the rest of
 * the app.
 */
export function PageFooter() {
  const { t } = useTranslation();

  return (
    <footer>
      <Version />
      <span className="footer-links">
        <a
          href={`${SITE}/datenschutz-webangebot/`}
          target="_blank"
          rel="noreferrer"
        >
          {t('footer.privacy')}
        </a>
        <a href={`${SITE}/kontakt/`} target="_blank" rel="noreferrer">
          {t('footer.contact')}
        </a>
        <a href={`${SITE}/impressum/`} target="_blank" rel="noreferrer">
          {t('footer.imprint')}
        </a>
        {/* the logo carries the link home, the way it does on the site;
            the label keeps it reachable without seeing the artwork */}
        <a
          className="footer-logo"
          href={SITE}
          target="_blank"
          rel="noreferrer"
          aria-label={t('footer.site')}
          title={t('footer.site')}
        >
          <HostsharingLogo />
        </a>
      </span>
    </footer>
  );
}
